import React from 'react';
// @ts-ignore
import visa from 'payment-icons/min/flat/visa.svg';
// @ts-ignore
import diners from 'payment-icons/min/flat/diners.svg';
// @ts-ignore
import discover from 'payment-icons/min/flat/discover.svg';
// @ts-ignore
import jcb from 'payment-icons/min/flat/jcb.svg';
// @ts-ignore
import mastercard from 'payment-icons/min/flat/mastercard.svg';
// @ts-ignore
import unionpay from 'payment-icons/min/flat/unionpay.svg';
// @ts-ignore
import amex from 'payment-icons/min/flat/amex.svg';
import { Logo } from './Styled';

type IconProps = {
    brand: string;
};

const Icon: React.FunctionComponent<IconProps> = ({ brand }) => {
    var image = null;
    switch (brand) {
        case "visa":
            image = visa
            break;
        case "diners":
            image = diners
            break;
        case "discover":
            image = discover
            break;
        case "jcb":
            image = jcb
            break;
        case "mastercard":
            image = mastercard
            break;
        case "unionpay":
            image = unionpay
            break;
        case "amex":
            image = amex
            break;
        default:
            break;
    }
    return <Logo src={image} />
};

export default Icon;